import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCustomerById } from '../../Customers/apiService';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { useCheckoutContext } from '../../../contexts/Checkout';

import { useUrlParams } from '../../../contexts/UrlParams';

import { getTicketsByAppointment } from '../../Service_Tickets/apiService';

const CustomerInfo = () => {
  const { values, setFieldValue } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  const { data: customer } = useQuery({
    queryKey: ['customer', values?.customer_id, values?.invoice_id],
    queryFn: () => getCustomerById(values?.customer_id),
    enabled: !!values?.customer_id,
    staleTime: Infinity
  });

  useEffect(() => {
    if (customer) {
      setFormValues(ofv => ({ ...ofv, customer}));
    }
  }, [customer]);

  
 
  return null;
};

export default CustomerInfo;